// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { DocumentScopeTab } from '../../types/document-filters';

export interface UseDocumentsToolbarProps {
  readonly scope: DocumentScopeTab;
  readonly onScopeChange: (scope: DocumentScopeTab) => void;
  readonly search: string;
  readonly onSearchChange: (event: ChangeEvent<HTMLInputElement>) => void;
  readonly activeFilterCount: number;
  readonly onOpenFilters: () => void;
  readonly disabled?: boolean;
  readonly hideScopeTabs?: boolean;
}

export const useDocumentsToolbar = ({
  scope,
  onScopeChange,
  search,
  onSearchChange,
  activeFilterCount,
  onOpenFilters,
  disabled = false,
  hideScopeTabs = false,
}: UseDocumentsToolbarProps) => {
  const { t } = useTranslation();

  return {
    t,
    scope,
    onScopeChange,
    search,
    onSearchChange,
    activeFilterCount,
    onOpenFilters,
    disabled,
    hideScopeTabs,
  };
};
